<template>
	<div class="recommend-cars-container" id="part_recommend">
		<p class="title">更多推荐</p>

		<ul class="recommend-cars car-list-wrapper">
			<li
				v-for="(item, index) in car.recommend"
				class="normal"
				@click="enterDetail(item)"
				v-sd-exp:VehicleDetailExpo="{
					page: '二手车车辆详情页',
					label_name: car.$$track_label_name,
					tag: car.$$track_tags,
					module_name: '更多推荐',
					position_rank: 7,
					position_in_rank: index + 1,
					position_in_number: 1,
					track_sign: 'aMall.b4307.exposure.VehicleDetailExpo'
				}"
				v-sd-clk:VehicleDetailClick="{
					page: '二手车车辆详情页',
					label_name: car.$$track_label_name,
					tag: car.$$track_tags,
					module_name: '更多推荐',
					button_name: '更多推荐',
					position_rank: 7,
					position_in_rank: index + 1,
					position_in_number: 1,
					track_sign: 'aMall.b4307.click.VehicleDetailClick'
				}"
			>
				<car-item theme="normal" :car="item" />
			</li>
		</ul>
	</div>
</template>

<script>
import CarItem from '@/components/CarItem'
import link from '@/util/link'
export default {
	name: 'RecommendCars',
	props: ['car'],
	components: { CarItem },

	methods: {
		enterDetail(carItem) {
			const { commodity_code, is_favorite } = carItem

			link.goToRoute('/detail', {
				sku_code: commodity_code,
				is_favorite
			})
		}
	}
}
</script>

<style lang="scss" scoped>
@import '~@nio-fe/nio-app-ui/es/style';

.recommend-cars-container {
	margin-top: 60px;

	.title {
		@include subtitle_1(1.4, 400, false);
		color: #040b29;
		margin-bottom: 20px;
	}

	.recommend-cars {
		.car-horizon-item {
			margin-bottom: 20px;
		}
	}
}
</style>
